// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__-On9T","tab":"ProcedureTabs_tab__1zViK"};